import Splide from '@splidejs/splide'

export default () => {
    const slideCache = [];

    const checkSlider = () => {
        const sliders = document.querySelectorAll('.slider');
        sliders.forEach(slider => {
            if(slider.getAttribute('data-slide-on-m') === ''){
                if(window.innerWidth <= 605){
                    if(slider.classList.contains('glide--ltr')){
                        return;
                    }

                    slideCache.push(new Splide(slider, {
                        type: 'carousel',
                        gap: 0
                    }).mount());
                } else {
                    while(slideCache.length > 0){
                        const slider = slideCache.pop();
                        slider.destroy();
                    }
                }
            } else {
                if(slider.classList.contains('glide--ltr')){
                    return;
                }
                new Splide(slider, {
                    type: 'carousel',
                    gap: 0
                }).mount();
            }
        });
    };

    window.addEventListener('resize', checkSlider);
    checkSlider();
}
